function numberToPercentage(number = 0.0) {
  return `${parseInt(Math.round(number), 10)}%`;
}

export default numberToPercentage;



// WEBPACK FOOTER //
// ./src/filters/numberToPercentage.js